import { PrismLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import iecst from 'react-syntax-highlighter/dist/esm/languages/prism/iecst';
import vs from 'react-syntax-highlighter/dist/esm/styles/prism/vs';

/**
 * Display structured text (ST) code with syntax highlighting
 */
const StBlock = ({ code }) => {
  SyntaxHighlighter.registerLanguage('iecst', iecst);

  return (
    <SyntaxHighlighter
      showLineNumbers={true}
      language="iecst"
      style={vs}
      lineNumberStyle={{
        minWidth: '3em'
      }}
      customStyle={{
        margin: 0,
        border: 0,
      }}
    >
      {code}
    </SyntaxHighlighter>
  );
};

export default StBlock;
